import BankBCI from '../../banksPNG/bankBCI.png';

interface IconProps {
	width?: string;
	height?: string;
	alt?: string;
}

export const BancoBciIcon = ({ width = '17px', height = '17px', alt = 'Banco BCI' }: IconProps) => (
	<img src={BankBCI} width={width} height={height} alt={alt} />
);
